import MaterialTable from "material-table";
import moment from "moment";
import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { AiFillPrinter } from "react-icons/ai";
import { useReactToPrint } from "react-to-print";
import AuthUser from "../../../Components/AuthUser";
import "./PosTransaction.css";
import ReactDatePicker from "react-datepicker";
import { transactionDetailsLang } from "../../../Components/language/pages/transactionDetailsLang";
import useLanguage from "../../../Components/language/useLanguage";
import { FaCheckCircle } from "react-icons/fa";
import Swal from "sweetalert2";

const DayClosing = () => {
  const { http, user } = AuthUser();
  const lan = useLanguage(transactionDetailsLang);
  const [invoices, setInvoices] = useState([]);
  const [update, setUpdate] = useState(false);
  useEffect(() => {
    http.get(`all-invoices`).then((res) => {
      setInvoices(res.data.data);
    });
  }, [update]);

  const columns = [
    {
      title: lan?.sl,
      field: "",
      render: (row) => <div>{row.tableData.id + 1}</div>,
      width: "20 !important",
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.invoiceNo,
      field: `invoice_no`,
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.member,
      field: `invoice_no`,
      render: (row) => (
        <div className="">
          {row.member?.member_name ? row.member?.member_name : "Not a member"}
        </div>
      ),
    },

    {
      title: lan?.date,
      field: `created_at`,
      render: (row) => (
        <div className="text-center">
          {moment(row?.updated_at).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      title: lan?.status,
      field: `payment_status`,
      render: (row) => (
        <div className="text-center">
          {row.payment_status === "Paid"
            ? lan?.paid
            : row.payment_status === "Partially Paid"
            ? lan?.partiallyPaid
            : lan?.unpaid}
        </div>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },
    // {
    //   title: lan?.subTotal,
    //   field: `sub_total`,
    //   render: (row) => (
    //     <div className="text-center">
    //       <span style={{ fontSize: "20px", fontWeight: 700 }}>&#x9F3;</span>
    //       {parseFloat(row.sub_total || 0).toFixed(2)}
    //     </div>
    //   ),
    // },
    // {
    //   title: lan?.discount,
    //   field: `special_discount`,
    //   render: (row) => (
    //     <div className="text-center">
    //       <span style={{ fontSize: "20px", fontWeight: 700 }}>&#x9F3;</span>
    //       {parseFloat(row.special_discount || 0).toFixed(2)}
    //     </div>
    //   ),
    // },
    {
      title: lan?.grandTotal,
      field: `special_discount`,
      render: (row) => (
        <div className="text-center">
          <span style={{ fontSize: "20px", fontWeight: 700 }}>&#x9F3;</span>
          {(
            parseFloat(row.sub_total || 0) -
            parseFloat(row.special_discount || 0)
          ).toFixed(2)}
        </div>
      ),
    },

    {
      title: "Closing Date",
      field: `discount_type`,
      render: (row) => (
        <div className="text-center">
          {row?.closing_date
            ? moment(row?.closing_date).format("DD/MM/YYYY")
            : ""}
        </div>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },
    {
      title: lan?.action,
      field: "patient",
      render: (row) => (
        <div className="text-center">
          <button
            data-bs-toggle="tooltip"
            title="Print Invoice"
            onClick={() => invoicePrint(row.id)}
            className={`btn btn-sm action-btn `}
          >
            <AiFillPrinter fontSize={20} />
          </button>
          <button
            data-bs-toggle="tooltip"
            title="Approve"
            disabled={row?.is_approved === 1}
            onClick={() => handleStockOut(row?.id)}
            className={`btn btn-sm action-btn ms-2 ${
              row?.is_approved === 1 ? "text-success" : ""
            }`}
          >
            <FaCheckCircle fontSize={18} />
          </button>
        </div>
      ),
      cellStyle: {
        textAlign: "center",
      },
    },
  ];
  const handleStockOut = (id) => {
    Swal.fire({
      title: lan?.approveConfirm,
      text: lan?.approveText,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: lan?.approve,
    }).then((result) => {
      if (result.isConfirmed) {
        http.post(`stock-out-by-id/${id}`).then((res) => {
          if (res.data.status === 200) {
            setUpdate(!update);
            Swal.fire({
              position: "top-center",
              icon: "success",
              title: lan?.success,
              text: lan?.message,
              timer: 2500,
            });
          }
        });
      }
    });
  };
  // print invoice
  const [invoiceData, setInvoiceData] = useState({
    invoice: {
      invoice_no: "",
      created_at: "",
      payment_status: "",
      grand_total: "",
    },
    invoiceDetails: [],
  });
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const invoicePrint = (id) => {
    http.get(`view-selected-invoice/${id}`).then((res) => {
      if (res.status === 200) {
        setInvoiceData({
          invoice: res.data.data,
          invoiceDetails: res.data.invoice_details,
        });
        setTimeout(() => {
          handlePrint();
        }, 500);
      }
    });
  };

  const [date, setDate] = useState({
    startDate: "",
    endDate: "",
  });

  const handleSearch = () => {
    http.post("serch-invoice-by-date", date).then((res) => {
      if (res.status === 200) {
        setInvoices(res.data.data);
      }
    });
  };

  return (
    <div className="page-content">
      <div className="row">
        <div className="col-lg-12 col-md-12">
          <div className="card mb-2">
            <div className="card-body">
              <div className="row">
                <div className="d-flex justify-content-between">
                  <h6>{lan?.pageTitle}</h6>
                  <div className="row mb-1">
                    <div className="col-1"></div>
                    <div className="col-sm-4">
                      <ReactDatePicker
                        placeholderText="From Date"
                        selected={
                          date.startDate ? new Date(date.startDate) : new Date()
                        }
                        className="form-control form-control-sm custom-datepicker-input-width"
                        dateFormat={"dd/MM/yyyy"}
                        name="requisition_no"
                        onChange={(d) =>
                          setDate({
                            ...date,
                            startDate: moment(d).format("YYYY-MM-DD"),
                          })
                        }
                      />
                      {/* <input
                        className={`form-control form-control-sm`}
                        type='date'
                        id='exampleInputUsername2'
                        onChange={(e) =>
                          setDate({ ...date, startDate: e.target.value })
                        }
                        name='requisition_no'
                      /> */}
                    </div>
                    <div className="col-sm-4">
                      <ReactDatePicker
                        className="form-control form-control-sm"
                        selected={
                          date.endDate ? new Date(date.endDate) : new Date()
                        }
                        dateFormat="dd/MM/yyyy"
                        onChange={(d) =>
                          setDate({
                            ...date,
                            endDate: moment(d).format("YYYY-MM-DD"),
                          })
                        }
                      />
                    </div>
                    <div className="col-sm-3">
                      <button
                        style={{
                          backgroundColor: "#69B128",
                          color: "white",
                          paddingTop: "6px",
                          paddingBottom: "7px",
                          marginTop: "1px",
                        }}
                        onClick={handleSearch}
                        className="btn btn-sm me-lg-2 px-4  fw-bold"
                      >
                        {lan?.search}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <MaterialTable
            columns={columns}
            data={invoices}
            // isLoading= {spinner ? true : false}
            options={{
              search: true,
              showTitle: false,
              searchFieldAlignment: "left",
              pageSize: 10,
              emptyRowsWhenPaging: false,
              pageSizeOptions: [5, 10, 20, 50, 100],
            }}
          />
        </div>
      </div>
      <div className="transaction-invoice">
        <div
          style={{ paddingLeft: "35px", paddingRight: "35px" }}
          ref={componentRef}
          className="invoice-print"
        >
          <div className="invoice-pharmacy-details d-flex align-items-center">
            <img
              src={user?.organization?.logo}
              className="img-fluid"
              style={{ height: "80px" }}
              alt=""
            />
            <div className="text-center flex-grow-1">
              <div style={{ marginLeft: "-80px" }}>
                <h5>{user?.organization?.name}</h5>
                <p>Location : {user?.organization?.address}</p>
                <p>Tel : {user?.organization?.mobile}</p>
                <h6 className="mt-2">{lan?.invoice}</h6>
              </div>
            </div>
          </div>
          <h6 className="text-center">Invoice </h6>
          <div className="invoice-date invoice-border-dashed d-flex justify-content-between">
            <div>
              <p>
                {" "}
                {lan?.name}: {invoiceData?.invoice?.member_name}
              </p>
              <p>
                {" "}
                {lan?.address}: {invoiceData?.invoice?.address}
              </p>
              <p>
                {" "}
                {lan?.mobile}: {invoiceData?.invoice?.mobile}
              </p>
              {/* <p>Sales Person : Dummy </p> */}
            </div>
            <div>
              <p style={{ textAlign: "end" }}>
                {lan?.invoiceNo} :{invoiceData?.invoice?.invoice_no}
              </p>
              <p style={{ textAlign: "end" }}>
                {lan?.date} :
                {moment(invoiceData?.invoice?.date).format("DD/MM/YYYY")}
              </p>
              <p style={{ textAlign: "end" }}>
                {lan?.printDateAndTime} :{" "}
                {moment().format("DD-MM-YYYY hh:mm A")}
              </p>
            </div>
          </div>
          <div className="invoice-item-table">
            <table>
              <tr className="invoice-border-dashed">
                <td width={"50%"}>{lan?.item}</td>
                <td width={"15%"} className="text-right">
                  {lan?.qty}
                </td>
                <td width={"10%"} className="text-right">
                  {lan?.unit}
                </td>
                <td width={"10%"} className="text-right">
                  {lan?.price}
                </td>
                <td width={"15%"} className="text-end">
                  {lan?.totalPrice}
                </td>
              </tr>
              {invoiceData.invoiceDetails.map((item, i) => (
                <tr key={i}>
                  <td width={"50%"}>
                    {item.name ? item.name : item.drug?.macrohealth_sg}
                  </td>
                  <td width={"10%"} className="text-start">
                    {item.pcs || item.qty}
                  </td>
                  <td width={"10%"} className="text-start">
                    {item.unit}
                  </td>
                  <td width={"10%"} className="text-start">
                    {item.sellingPrice}
                  </td>
                  <td width={"15%"} className="text-end">
                    {item?.total_price}
                  </td>
                </tr>
              ))}
              <tr className="invoice-border-dashed-top">
                <td colSpan={4} className="text-end fw-bolder">
                  {lan?.subTotal} :
                </td>
                <td className="text-end">
                  {Number(invoiceData.invoice?.grand_total).toFixed(2)}
                </td>
              </tr>

              <tr>
                <td colSpan={4} className="text-end">
                  {lan?.deliveryCharge} :
                </td>
                <td className="text-end">
                  {parseFloat(
                    invoiceData?.invoice?.delivery_charge || 0
                  ).toFixed(2)}
                </td>
              </tr>

              <tr>
                <td colSpan={4} className="text-end">
                  {lan?.discount} :
                </td>
                <td className="text-end">
                  {parseFloat(invoiceData?.invoice?.special_discount || 0)}{" "}
                </td>
              </tr>
              {/* <tr>
                <td colSpan={3} className='text-end'>
                  Special Discount :
                </td>
                <td className='text-end'>{0} </td>
              </tr> */}
              <tr className="invoice-border-dashed-top">
                <td colSpan={4} className="text-end fw-bold">
                  {lan?.grandTotal} :
                </td>
                <td className="text-end">
                  {parseFloat(
                    parseFloat(invoiceData?.invoice?.grand_total || 0) -
                      parseFloat(invoiceData?.invoice?.special_discount || 0)
                  ).toFixed(2)}
                </td>
              </tr>
              <tr className="invoice-border-dashed-top mt-3">
                <td colSpan={3} className="text-end fw-bolder">
                  {lan?.lastDue} :{" "}
                </td>
                <td>{invoiceData?.invoice?.last_due_date}</td>
                <td className="text-end">{invoiceData?.invoice?.last_due}</td>
              </tr>
              <tr className="invoice-border-dashed-top mt-3">
                <td colSpan={4} className="text-end fw-bolder">
                  {lan?.paid} :{" "}
                </td>
                <td className="text-end">
                  {invoiceData?.invoice?.paid_amount}
                </td>
              </tr>
              <tr className="invoice-border-dashed-top mt-3">
                <td colSpan={4} className="text-end fw-bolder">
                  {lan?.presentDue} :{" "}
                </td>
                <td className="text-end">
                  {invoiceData?.invoice?.present_due}
                </td>
              </tr>
            </table>
          </div>
          <div className=" invoice-creator mt-1">
            <p>
              {lan?.providedBy}: {invoiceData?.invoice?.created_by}
            </p>
            {/* <p>Time : {new Date().toLocaleTimeString()}</p> */}
            {/* <p>Date : {new Date().toLocaleDateString('en-GB')} </p> */}
          </div>

          <div className="d-flex justify-content-center branding-section mt-5">
            <p>{lan?.thankYou}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DayClosing;
